module.exports = "/static/assets/86c0614a225dd4e26ccd51cd06e3b2af.png";